module.exports = __webpack_public_path__ + "static/img/web_banner001.d58d6a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/web_banner001.jpg
// module id = FGeH
// module chunks = 15